import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="dr-container">
      <div className="dr-bg-gradient"></div>
      <div className="dr-grid-bg"></div>

      <main className="dr-card">
        {/* Animated Graphic */}
        <div className="dr-graphic">
          <svg viewBox="0 0 200 200">
            <circle cx="100" cy="90" r="30" className="dr-main-circle" />
            <line x1="121" y1="111" x2="145" y2="135" className="dr-line" />
            <rect x="70" y="100" width="60" height="60" rx="6" className="dr-box" />
            <rect x="110" y="80" width="60" height="60" rx="6" className="dr-box-light" />
          </svg>
        </div>

        {/* Content */}
        <div className="dr-text">
          <h1>404</h1>

          <h2>Page not found</h2>

          <p>
            The page you're looking for doesn't exist or was moved.
            Let's get you back to Draptor marketplace.
          </p>

          <Link to="/" className="dr-btn">
            Go to Homepage
            <span>→</span>
          </Link>
        </div>
      </main>

      <footer className="dr-footer">
        © {new Date().getFullYear()} Draptor Technologies
      </footer>
    </div>
  );
}